<template>
    <div class="main">
        <c-panel title="EQUIPAMENTOS BIOMÉTRICOS" titleIcon="fas fa-door-open">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Catracas, totens, câmeras e tablets de reconhecimento facial instalados nas escolas."
                description="Cada equipamento tem um token próprio, exibido uma única vez na criação. O equipamento é identificado pelo token, nunca pelo que envia no corpo da requisição."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou identificador..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="6">
                    <el-select v-model="filtro.instituicao_id" clearable filterable placeholder="Escola" style="width: 100%;" @change="carregar">
                        <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="5" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/biometria/equipamento/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO EQUIPAMENTO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Equipamento</th>
                            <th style="width: 130px;">Identificador</th>
                            <th class="hidden-mobile">Escola</th>
                            <th style="width: 110px;">Direção</th>
                            <th style="width: 130px;" class="u-text-center">Conexão</th>
                            <th style="width: 90px;" class="u-text-center">Eventos hoje</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="e in items" :key="e.id">
                            <td>
                                {{ e.nome }}
                                <div><small class="u-text-muted">{{ rotuloTipo(e.tipo) }}<span v-if="e.local"> · {{ e.local }}</span></small></div>
                            </td>
                            <td>{{ e.identificador }}</td>
                            <td class="hidden-mobile">{{ e.instituicao ? e.instituicao.nome : '—' }}</td>
                            <td>{{ rotuloDirecao(e.direcao) }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corConexao(e.status_conexao)">{{ rotuloConexao(e.status_conexao) }}</el-tag>
                                <div v-if="e.ultimo_heartbeat"><small class="u-text-muted">{{ dataHora(e.ultimo_heartbeat) }}</small></div>
                            </td>
                            <td class="u-text-center">{{ e.qtd_eventos_hoje }}</td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" @click="regerar(e)" size="mini" plain title="Gerar novo token">TOKEN</el-button>
                                <router-link v-if="podeEscrever" :to="'/admin/biometria/equipamento/edit/' + e.id" class="link-icon u-mr-10 u-ml-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(e.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="7" class="u-text-center">Nenhum equipamento cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <!-- ==================== TOKEN — exibido UMA vez ==================== -->
            <el-dialog title="Token do equipamento" :visible.sync="dialogoToken" width="620px" :close-on-click-modal="false">
                <el-alert type="warning" :closable="false" class="u-mb-15"
                    title="Copie o token agora."
                    :description="avisoToken"></el-alert>
                <el-input v-model="tokenGerado" readonly>
                    <el-button slot="append" icon="el-icon-document-copy" @click="copiar">COPIAR</el-button>
                </el-input>
                <small class="u-text-muted">
                    Configure no equipamento o cabeçalho <code>Authorization: Bearer &lt;token&gt;</code>.
                </small>
                <span slot="footer"><el-button type="primary" @click="dialogoToken = false">JÁ COPIEI</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO J — itens 127, 128 e 129. Interface para `api/equipamento-biometrico`. */
export default {
    data: () => ({
        statusList: false, filtro: { nome: '', tipo: '', instituicao_id: '' }, items: [],
        instituicoes: [], tipos: ['catraca', 'totem', 'camera', 'tablet'],
        dialogoToken: false, tokenGerado: '', avisoToken: ''
    }),
    computed: {
        podeEscrever () { return [0, 1, 4, 5, 6, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = (r.data && r.data.instituicoes) ? r.data.instituicoes : [] })
         .catch(() => {})

        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); this.statusList = true; return }
                this.items = r.data.data || []; this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        rotuloTipo (t) {
            return { catraca: 'Catraca', totem: 'Totem', camera: 'Câmera', tablet: 'Tablet' }[t] || t
        },
        rotuloDirecao (d) {
            return { entrada: 'Só entrada', saida: 'Só saída', ambos: 'Entrada e saída' }[d] || d
        },
        rotuloConexao (s) {
            return { online: 'Online', offline: 'Offline', sem_heartbeat: 'Sem heartbeat' }[s] || s
        },
        corConexao (s) {
            return { online: 'success', offline: 'danger', sem_heartbeat: 'info' }[s] || 'info'
        },
        dataHora (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]} ${d.substring(11, 16)}`
        },
        regerar (e) {
            this.$confirm(`Gerar um token novo para "${e.nome}"? O token atual deixa de funcionar imediatamente e o equipamento precisará ser reconfigurado.`,
                'Confirmação', { confirmButtonText: 'Gerar novo', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/regerarToken/${e.id}`,
                    {}, this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    this.tokenGerado = r.data.token
                    this.avisoToken = r.data.aviso_token
                    this.dialogoToken = true
                }).catch(err => this.$store.commit('throwException', err))
            }).catch(() => {})
        },
        copiar () {
            const el = document.createElement('textarea')
            el.value = this.tokenGerado
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            el.remove()
            window.eventBus.$emit('alert', { msg: 'Token copiado.', type: 'success' })
        },
        excluir (id) {
            this.$confirm('Excluir este equipamento?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Equipamento excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
